<template>
  <DeepAvatar
    v-tooltip:top="genericFolder?.displayName"
    color="transparent"
    tile
  >
    <template #logo>
      <BoxGenericsIcon :generic-folder="genericFolder" />
    </template>
  </DeepAvatar>
</template>

<script setup lang="ts">
import { DeepAvatar } from '@deepcloud/deep-ui-lib'
import BoxGenericsIcon from '@/components/box/generics/BoxGenericsIcon.vue'
import type { GenericFolder } from '@deepcloud/api-deep-box'

defineProps({
  genericFolder: {
    type: Object as PropType<GenericFolder>,
    default: undefined,
  },
})
</script>
